import request from '@/axios/request';

// 获得福建地标首页内容（所有）
export const getCmsHomeDataList = (params: any) =>
  request({
    url: 'cms_v2/cms_home/getCmsHomeDataList',
    method: 'get',
    params
  });


// 获得福建地标首页内容(独立)
export const getCmsHomeFirstPage = (params: any) =>
  request({
    url: 'cms_v2/cms_home/getCmsHomeFirstPage',
    method: 'get',
    params
  });


// 地标门户网站
export const getCmsLandmarkDetail = (params: any) =>
  request({
    url: 'cms_v2/cms_home/getCmsLandmarkDetail',
    method: 'get',
    params
  });

// 地标企业详情
export const getCmsCompanyDetail = (params: any) =>
  request({
    url: 'cms_v2/cms_home/getCmsCompanyDetail',
    method: 'get',
    params
  });

// 地标文章详情
export const getCmsArticleDetail = (params: any) =>
  request({
    url: 'cms_v2/cms_home/getCmsArticleDetail',
    method: 'get',
    params
  });
  

// 地标文章列表
export const getCmsColumnDetail = (params: any) =>
  request({
    url: 'cms_v2/cms_home/getCmsColumnDetail',
    method: 'get',
    params
  });  


// 地标分页
export const getLandmarkListByPage = (params: any) =>
  request({
    url: 'cms_v2/cms_home/getLandmarkListByPage',
    method: 'get',
    params
  });  

// vr分页
export const getVrListByPage = (params: any) =>
  request({
    url: 'cms_v2/cms_home/getVrListByPage',
    method: 'get',
    params
  }); 

// 视频分页
export const getVideoListByPage = (params: any) =>
  request({
    url: 'cms_v2/cms_home/getVideoListByPage',
    method: 'get',
    params
  }); 

  // 新视频分页
export const getVideoListByPageNew = (params: any) =>
request({
  url: 'cms/cms_home/getVideoListByPage',
  method: 'get',
  params
}); 


// 地标商城
export const getProductListByPage = (params: any) =>
  request({
    url: 'cms_v2/cms_home/getProductListByPage',
    method: 'get',
    params
  }); 
  
// 搜索
export const informationQueryListByPage = (params: any) =>
  request({
    url: 'cms_v2/cms_home/informationQueryListByPage',
    method: 'get',
    params
  }); 


// 头部数据
export const headerData = (params: any) => 
  request({
    url: 'cms_v2/cms_home/headerData?',
    method: 'post',
    params
  })  

// 获得地标第几期
export const getLandmarkPeriodsInformation = (params: any) => 
  request({
    url: 'cms_v2/cms_home/getLandmarkPeriodsInformation',
    method: 'post',
    params
  })
